import { defineComponent as _defineComponent } from 'vue'
import SoftwareCategoryTryDemoForm from '~/components/sections/categorySection/SoftwareCategoryTryDemoForm.vue';
import { useModalDialog } from '~/composables';

interface Props {
  data?: any;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SoftwareCategoryTryDemoFormModal',
  props: {
    data: { default: () => ({}) }
  },
  setup(__props: any) {

const props = __props as { data: any };



const { isOpen: isFormModalOpen } = useModalDialog(props.data.id);
const { isOpen: isInfoModalOpen, close: closeInfoModal } = useModalDialog(
  `${props.data.id}-info`,
);

return { __sfc: true,props, isFormModalOpen, isInfoModalOpen, closeInfoModal, SoftwareCategoryTryDemoForm }
}

})